import { t } from "i18next";

import { DEFAULT_DUPONT_FILTER_CATEGORIES } from "../UFConfiguration/UFProductGuidelines/UFProductGuidelines.constant";

import { UF_MODULE_PER_RACK_RANGE, UFTechnologies } from "./UFConstants";

export const createUFCommonInitialState = () => ({
  ufModulesByCompany: {},
  ufInputRangeConfig: [],
  ufInputRangeConfigByWaterType: [],
  ufPHGuidline: [],
  ufModuleFlowVM: [],
  ufFluxGuideline: [],
  ufModulePressureRatingVM: [],
  ufDoseGuidline: [],
});

export const createUFNodeInitialState = () => ({
  ufCompany: "",
  isUFDetailsFetched: false,
  isUFConfigLoading: false,
  isUFSystemDiagramHidden: false,
  isUpdateActiveModule: false,
  isSysDesignVisible: true,
  ingeTROption: null,
  activeUFModule: {},
  ufTechnologies: UFTechnologies(t),
  ufModules: [],
  ufStandByOptions: [],
  ufStorageTankOptions: [],
  defaultInputRangeConfig: {},
  data: {},
  isForDrinkingWater: false,
  sliderValue: UF_MODULE_PER_RACK_RANGE.max,
  sliderMin: UF_MODULE_PER_RACK_RANGE.min,
  sliderMax: UF_MODULE_PER_RACK_RANGE.max,
  calcEngineData: {},
  recommended_configs: [],
  defaultUFConfig: {},
  callCalcEngineUFConfig: false,
  isCustomConfigAvail: false,
  isOfflineTimeChanged: false,
  isUfDataUpdated: false,
  calcEngineDataRefreshCount: -1,
  isRecommendationCalucalting: false,
  autoSelectTRack: false,
  ufProductFilter: {
    selectedModuleCategory: DEFAULT_DUPONT_FILTER_CATEGORIES(t),
    activeSortOrder: "",
    activeSearch: "",
    isValidForFiltering: false, // TODO : Should not be in redux, move to local state
  },
  isLastFieldOnAdittionSettingScreen: false,
  ufChemicalScreenInitialized: {},
  ufInvalidData: {},
});

export const ufNodeInitialState = createUFNodeInitialState();

export const createUFStoreInitialState = () => ({
  ...createUFCommonInitialState(),
  nodes: {},
});

const UFStoreInitialState = createUFStoreInitialState();

export default UFStoreInitialState;
